const AdvertisingShowcase: React.FC = () => {
  const handleAirportSolutions = () => {
    // Trigger the contact modal from the parent component
    const event = new CustomEvent('openContactModal');
    window.dispatchEvent(event);
  };

  return (
    <section className="relative py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-20">
        <div className="w-full h-full bg-gradient-to-r from-blue-600/30 to-purple-600/30 animate-pulse"></div>
      </div>
      
      {/* Parallax Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-10 sm:top-20 left-5 sm:left-10 w-20 h-20 sm:w-32 sm:h-32 bg-gradient-to-br from-gold-400 to-yellow-500 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute bottom-10 sm:bottom-20 right-5 sm:right-10 w-32 h-32 sm:w-48 sm:h-48 bg-gradient-to-br from-silver-400 to-gray-300 rounded-full opacity-15 animate-bounce" style={{ animationDuration: '3s' }}></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-48 sm:w-24 sm:h-96 bg-gradient-to-b from-blue-400 to-purple-600 opacity-10 transform rotate-12 animate-pulse" style={{ animationDuration: '4s' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          <div className="text-white space-y-4 sm:space-y-6 lg:space-y-8">
            <div className="space-y-3 sm:space-y-4">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold leading-tight">
                High-Impact 3D Anamorphic Advertising
              </h2>
              <h3 className="text-base sm:text-lg lg:text-xl text-blue-200 font-medium">
                Immersive Visual Experiences for Global Brands
              </h3>
              <h4 className="text-sm sm:text-base lg:text-lg text-gray-200">
                Next-Generation Outdoor & Digital OOH Solutions
              </h4>
            </div>
            
            <p className="text-sm sm:text-base lg:text-lg text-gray-200 leading-relaxed">
              We deliver cutting-edge 3D advertising experiences using ultra-high-resolution LED screens and advanced anamorphic design techniques. Our team produces immersive campaigns that elevate brand visibility and generate viral global exposure.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/portal?modal=consultation')}
                className="bg-gradient-to-r from-gold-500 to-yellow-600 text-black px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:shadow-2xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                Get 3D Campaign Quote
              </button>
              <button 
                onClick={handleAirportSolutions}
                className="border-2 border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm text-sm sm:text-base"
              >
                Airport Solutions
              </button>
            </div>

            <div className="flex items-center gap-4 sm:gap-6 pt-2 sm:pt-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-3d-view-line text-lg sm:text-xl text-gold-400"></i>
              </div>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-building-line text-lg sm:text-xl text-silver-400"></i>
              </div>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-global-line text-lg sm:text-xl text-blue-400"></i>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-video bg-gradient-to-br from-blue-600/20 to-purple-600/20 rounded-2xl backdrop-blur-sm border border-white/10 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/94a9710eb79caa713057f2fa152edc3b.jpg"
                alt="3D Anamorphic Advertising Display"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-4 sm:-bottom-6 -left-3 sm:-left-6 bg-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 border border-white/20">
              <div className="text-lg sm:text-2xl font-bold text-white">+340%</div>
              <div className="text-xs sm:text-sm text-gray-300">Engagement Rate</div>
            </div>
            
            <div className="absolute -top-4 sm:-top-6 -right-3 sm:-right-6 bg-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 border border-white/20">
              <div className="text-lg sm:text-2xl font-bold text-white">50M+</div>
              <div className="text-xs sm:text-sm text-gray-300">Daily Impressions</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvertisingShowcase;
